var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout-base",
    { attrs: { title: _vm.$t("FINISH.THANKS") } },
    [
      _c(
        "div",
        {
          staticClass: "bk-reg-finish-text",
          attrs: { slot: "content" },
          slot: "content"
        },
        [
          _c("p", [_vm._v(_vm._s(_vm.$t("FINISH.DESCRIPTION")))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("FINISH.HOW_CONTINUE")))]),
          _vm._v(" "),
          _c("div", { staticClass: "bk-reg-apps" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("FINISH.USE_AS_APP")))]),
            _vm._v(" "),
            _c("div", { staticClass: "bk-reg-apps__container" }, [
              _c(
                "a",
                {
                  staticClass: "bk-reg-apps__container__android-badge",
                  attrs: { href: _vm.androidUrl, target: "_blank" },
                  on: {
                    click: function($event) {
                      return _vm.fireAndroidEvent()
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "bk-reg-apps__container__icon",
                    attrs: {
                      src:
                        "https://registration.bildkontakte.de/assets/badge_android.png",
                      alt: _vm.$t("FINISH.ANDROID_ALT_TAG")
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "bk-reg-apps__container__ios-badge",
                  attrs: { href: _vm.iosUrl, target: "_blank" },
                  on: {
                    click: function($event) {
                      return _vm.fireIosEvent()
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "bk-reg-apps__container__icon",
                    attrs: {
                      src:
                        "https://registration.bildkontakte.de/assets/badge_ios.svg",
                      alt: _vm.$t("FINISH.IOS_ALT_TAG")
                    }
                  })
                ]
              )
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "buttons" },
        [
          _c("p", { staticClass: "bk-reg-finish-text" }, [
            _vm._v(_vm._s(_vm.$t("FINISH.USE_IN_BROWSER")))
          ]),
          _vm._v(" "),
          _c("bk-button", { on: { click: _vm.openWebpage } }, [
            _vm._v(_vm._s(_vm.$t("GLOBAL.CONTINUE")))
          ])
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }